<style>
  .table td{
  color:white !important;
}
</style>


@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid mb-4">
    <div class="policy-main pb-3" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
      <h1 class="policy-heading">

        <i class="fa fa-arrow-circle-left" routerLink="/setting"></i>

        All Policies
      </h1>
      <div class="btn btn-primary" routerLink="/add-policy">
        + Add New Policy
      </div>
    </div>
    <div class="data-table">
      <div class="table-headings" >
        <div class="row">
          <div class="col-2 table-head" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <h3>Policy Title</h3>
          </div>
          <div class="col-8 table-head" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <h3>Policy Description</h3>
          </div>
          <div class="col-2 table-head action" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <h3>Action</h3>
          </div>
        </div>
      </div>
      @for (data of policyDetail; track data) {
        <div class="table-data-main">
          <div class="row data-row">
            <div class="col-2 table-head" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
              <h4>{{data.policy_title}}</h4>
            </div>
            <div class="col-8 table-data description" [ngClass]="{ 'dark-descript': selectedMode === 'dark' }">
              <div [innerHTML]="data.policy_description"></div>
            </div>
            <div class="col-2 table-data">
              <div class="row">
                <div class="col-6 icons">
                  <i class="fa fa-edit edit" (click)="editPolicy(data)" ></i>
                </div>
                <div class="col-6 icons">
                  <i class="fa fa-trash delete" data-toggle="modal" data-target="#deleteModal" ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Delete Modal -->
        <!-- Modal -->
        <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteModalTitle" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h3 class="modal-title" id="deleteModalTitle">Are You Sure?</h3>
              </div>
              <div class="modal-body">
                <img src="../../../assets/images/question.jpg" alt="Missig Image">
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" (click)="deletepolicy(data.id)">Delete</button>
              </div>
            </div>
          </div>
        </div>
      }


    </div>
  </div>
</main>